export function initHazardSection() {
    document.querySelectorAll(".js-itemcardHazardToggle").forEach((btn) => {
        if (btn.dataset.hazardBound === "1") return;
        btn.dataset.hazardBound = "1";
        btn.addEventListener("click", () => {
            const id = btn.getAttribute("aria-controls");
            const body = id ? document.getElementById(id) : null;
            if (!body) return;
            const open = btn.getAttribute("aria-expanded") === "true";
            btn.setAttribute("aria-expanded", String(!open));
            body.hidden = open;
            const wrap = btn.closest(".itemcardHazard");
            if (wrap) {
                wrap.classList.toggle("itemcardHazard--open", !open);
            }
        });
    });
}
